(() => {
  let pending = false;

  const update = () => {
    pending = false;
    document.querySelectorAll('.ddreview-star').forEach((widget) => {
      const count = widget.querySelector('.dd-review-count')?.textContent.trim();
      const empty = typeof count === 'string' && /^\(?\s*0\s*\)?$/.test(count);
      widget.classList.toggle('cws-empty-review-stars', empty);
    });
  };

  const schedule = () => {
    if (pending) return;
    pending = true;
    queueMicrotask(update);
  };

  const start = () => {
    update();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
